import React from "react";
import Properties from "./Properties";

import './PropertiesPage.css'

function PropertiesPage(){
return(
    <div className="propertiesContainer">
        <Properties/>

        <h2 id="propertySearchHeader">If you would like to see some of the homes offered in your area, 
            feel free to use this tool to show what you have around!</h2>

        <iframe title="Public Listings" 
        src="https://apexidx.com/idx_lite/advancedsearch/EN/_LA/" 
        id="publicSearch"
        scrolling="no"
        seamless="seamless">
        
        </iframe>

        
    </div>
    )
}

export default PropertiesPage;